import { SET_OPTIONS } from '../actions/types';

export default function (state = null, action) {
	if (action.type === SET_OPTIONS) {
		return action.payload;
	}
	return state;
}
